import axios from 'axios'

import { resolveRequest } from 'utility-tools/module/requests'

import { IPaymentPreferenceDto } from './api.types'
import constants from 'nexchange-service/constants'

const { API_URL } = constants


const requestPaymentPreferenceDetails = async () =>
    resolveRequest<IPaymentPreferenceDto[]>(
        axios.get(`${API_URL}/users/me/payment_preference/`)
    )

const requestCreateZeroPaymentPreference = async () =>
    resolveRequest<any>(
        axios.get(`${API_URL}/zero_amount_payment_request/?currency=EUR&payment_method=worldpay`)
    )
export { requestPaymentPreferenceDetails, requestCreateZeroPaymentPreference }
